import RequireUserMiddleware from 'middlewares/RequireUserMiddleware'
import RequirePhysicianOrAncillaryMiddleware from 'middlewares/RequirePhysicianOrAncillaryMiddleware'
import RequireSignupFinishedMiddleware from 'middlewares/RequireSignupFinishedMiddleware'

export default [
    {
        path: '/network/connections',
        name: 'network.connections',
        view: 'network/Connections',
        default: { query: { status: 'all' } },
        middlewares: [RequireSignupFinishedMiddleware, RequirePhysicianOrAncillaryMiddleware, RequireUserMiddleware],
    },
    ...[
        { type: 'invite', action: 'physicians' },
        { type: 'invite', action: 'service-providers' },
    ].map(({ type, action }) => ({
        path: `/network/${type}/${action}`,
        name: `network.${type}.${action}`,
        view: 'network/Connections',
        default: { params: { type, action } },
        middlewares: [RequireSignupFinishedMiddleware, RequirePhysicianOrAncillaryMiddleware, RequireUserMiddleware],
    })),
    {
        path: '/network/request-appointment-at-join-invite/:id',
        name: 'network.request-invite-at-join-invite',
        view: 'network/RequestAppointmentAtJoinInvite',
        middlewares: [RequireSignupFinishedMiddleware, RequirePhysicianOrAncillaryMiddleware, RequireUserMiddleware],
    },
]
